import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const deleteQuoteLine = async (id: number) => {
  return await axiosInstance
    .delete(`quotes/lines/${id}`)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useDeleteQuoteLine = () => {
  return useMutation({
    mutationFn: (id: number) => deleteQuoteLine(id),
    mutationKey: ["quotes"],
  });
};

export default useDeleteQuoteLine;
